import { create as createSelector } from '@spazious/dollhouse-selector';
import { hasOwnProperty } from '@spazious/dollhouse-utils';

import { Migration, MigrationVersionEnum } from './types.js';

const itemTypes = ['fcomposition', 'farrangement', 'furniture', 'farea', 'fpolygon'] as const;

type MigrationItemTypes = (typeof itemTypes)[number];

export type MigrationStateV0_0_0 = {
  type: MigrationItemTypes;
  id: number;
  props?: Record<string, any>;
  attrs?: Record<string, any>;
  meta?: Record<string, any>;
}[];

export type MigrationStateV1_0_0 = {
  type: MigrationItemTypes;
  selector: string;
  id: number;
  attrs?: Record<string, any>;
  meta?: Record<string, any>;
}[];

export const migration_1_0_0: Migration<
  MigrationVersionEnum.v1_0_0,
  MigrationStateV0_0_0,
  MigrationStateV1_0_0
> = {
  version: MigrationVersionEnum.v1_0_0,
  check: (state) =>
    Array.isArray(state) &&
    state.length !== 0 &&
    state.some((node) => !hasOwnProperty(node, 'selector')),
  migrate: (state) => {
    return state.map(({ id, type, props = {}, attrs, meta }, idx) => {
      if (!itemTypes.includes(type)) {
        throw new Error(`Unknown type: ${type}`);
      }
      return Object.entries({
        id,
        type: type as MigrationItemTypes,
        selector: createSelector(idx, null),
        ...props,
        attrs,
        meta,
      }).reduce(
        (acc, [key, value]) => (value !== undefined ? { ...acc, [key]: value } : acc),
        {} as MigrationStateV1_0_0[number]
      );
    });
  },
};
